import * as React from 'react';
import { Component } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import styles from '../../styles/forms/copy_meeting_items_to_meeting_wizard/CopyMeetingItemsToMeetingForm.scss';
import Button from '../../components/Button';
import { connect } from 'react-redux';
import { __ } from '../../core/utils';
import Select from '../../components/Select';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import { listExistingMeetings } from '../../redux/actions/table/all_meetings';
import * as _ from 'lodash';

const mapStateToProps = (state) => {
  return {
    values: getFormValues(
      'copy_meeting_items_to_meeting_wizard.copy_meeting_items_to_meeting'
    )(state),
    stage_id: _.get(
      state.table,
      'all_meetings.copy_meeting_items_to_meeting_wizard.stage_id'
    ),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      hideCopyMeetingItemsToMeetingWizard: () =>
        dispatch({
          type: 'table.all_meetings/SET_TABLE_PARAMS',
          params: {
            copy_meeting_items_to_meeting_wizard: undefined,
          },
        }),
    },
  };
};

@withRouter
@subscribe(Localization, 'localization')
@reduxForm({
  form: 'copy_meeting_items_to_meeting_wizard.copy_meeting_items_to_meeting',
})
@connect(mapStateToProps, mapDispatchToProps)
class CopyMeetingItemsToMeetingForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      existing_meetings: [],
    };
  }

  componentDidMount() {
    listExistingMeetings(this.props.stage_id).then(({ response }) => {
      this.setState({ existing_meetings: response.data });
    });
  }

  render() {
    const new_meeting = _.get(this.props.values, 'new_meeting');
    const current_meeting_id = _.get(this.props, 'match.params.meeting');
    const existing_meetings = _.map(
      _.filter(
        this.state.existing_meetings,
        (meeting) => _.toString(meeting.id) !== _.toString(current_meeting_id)
      ),
      (meeting) => ({
        label:
          'M-' + _.padStart(meeting.identifier, 4, '0') + ': ' + meeting.title,
        value: meeting.id,
      })
    );

    return (
      <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
        <div className={styles.form}>
          {/* <div className={styles.chooser}>
            <div
              className={classNames(
                styles.option,
                this.props.values.new_meeting && styles.selected
              )}
              onClick={() => this.props.change('new_meeting', true)}
            >
              <span />
              {__(
                'meetings.all-meetings.copy-meeting-items-to-meeting.new-meeting'
              )}
            </div>
            <div
              className={classNames(
                styles.option,
                !this.props.values.new_meeting && styles.selected
              )}
              onClick={() => this.props.change('new_meeting', false)}
            >
              <span />
              {__(
                'meetings.all-meetings.copy-meeting-items-to-meeting.add-to-existing-meeting'
              )}
            </div>
          </div> */}
          <div className={styles.selector}>
            {!new_meeting && (
              <Field
                name='child_meeting_id'
                component={Select}
                noSort
                searchable
                label={__('wizard.meeting.label.add-to-existing-meeting')}
                options={existing_meetings}
              />
            )}
          </div>
        </div>
        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={this.props.actions.hideCopyMeetingItemsToMeetingWizard}
          />
          <Button
            lightBlue
            medium
            right
            submit
            middleText={__('button.next')}
            spinning={this.props.submitting}
          />
        </div>
      </Form>
    );
  }
}

export default CopyMeetingItemsToMeetingForm;
